import { sortBy } from "lodash";
import { forEach, isEmpty, isNull, remove, uniq } from "lodash-es";
import { sortByKey } from "./sort";

// 부서별 트리 데이터 세팅
const setTreeDataByParts = (parts, checked) => {
  let partsTreeData;
  const firstChildren = parts.filter((part) => isNull(part.parentIdx));
  const sortedParts = sortBy(firstChildren, ['sort'])
  partsTreeData = sortedParts.map((child) => ({
    ...child,
    title: child.partName,
    key: `part-${child.idx}`,
    sort: child.sort,
    isPart: true,
    children: [],
    isChecked: checked
  }));

  findChildren(partsTreeData, parts, checked);

  return partsTreeData;
};

const findChildren = (targetData, originData, checked) => {
  forEach(targetData, (target) => {
    forEach(originData, (origin) => {
      if (target.idx === origin.parentIdx) {
        target.children.push({
          ...origin,
          title: origin.partName,
          key: `part-${origin.idx}`,
          sort: origin.sort,
          isPart: true,
          children: [],
          isChecked: checked
        });
      }

      sortByKey(target.children, "sort");
    });
    return findChildren(target.children, originData, checked);
  });
};

// 트리 데이터에 직원 정보 매칭
const matchEmployee = (targetData, employees, type) => {
  switch (type) {
    case "grade":
      forEach(targetData, (target) => {
        forEach(employees, (employee) => {
          if (target.key === `grade-${employee.gradeIdx}`) {
            target.children.push({
              ...employee,
              title: employee.name,
              key: employee.idx,
              isEmployee: true,
              isChecked: true,
              profileImg: employee.profileImg,
              children: [],
            });
          } else if (
            target.key === "unspecified" &&
            isNull(employee.gradeIdx)
          ) {
            target.children.push({
              ...employee,
              title: employee.name,
              key: employee.idx,
              isEmployee: true,
              isChecked: true,
              profileImg: employee.profileImg,
              children: [],
            });
          }
        });
        matchEmployee(target.children, employees);
      });
      break;
    default:
      forEach(targetData, (target) => {
        forEach(employees, (employee) => {
          if (target.isPart && target.key === `part-${employee.partIdx}`) {
            target.children.push({
              ...employee,
              title: employee.name,
              key: employee.idx,
              isEmployee: true,
              isChecked: true,
              profileImg: employee.profileImg,
              children: [],
            });
          } else if (target.key === "unspecified" && isNull(employee.partIdx)) {
            target.children.push({
              ...employee,
              title: employee.name,
              key: employee.idx,
              isEmployee: true,
              isChecked: true,
              profileImg: employee.profileImg,
              children: [],
            });
          }
        });
        matchEmployee(target.children, employees);
      });
      break;
  }

  return targetData;
};

// 선택된 트리데이터 찾기
const findSelectedNode = (nodeList) => {
  let changedArray = [];
  let removeArray = [];

  forEach(nodeList, (node) => {
    if (!isEmpty(node.children)) {
      forEach(node.children, (child) => {
        forEach(nodeList, (n) => {
          if (child.key === n.key) {
            removeArray.push(n);
            changedArray.push(node);
          }
        });
        if (!isEmpty(child.children)) {
          findSelectedNode(child.children);
        }
      });
    } else {
      changedArray.push(node);
    }
  });
  changedArray = uniq(changedArray);
  forEach(removeArray, (data) => {
    remove(changedArray, data);
  });

  return changedArray;
};

export { setTreeDataByParts, matchEmployee, findSelectedNode };

// {
//   title: '',
//   key: '',
//   children: [
//     {
//     title: '',
//     key: '',
//     children: [
//       {
//         title: '',
//         key: '',
//         children: []
//         },
//     ]
//     },
//     {
//       title: '',
//       key: '',
//       children: [
//         {
//           title: '',
//           key: '',
//           children: []
//           },
//       ]
//       },
//   ]
// }
